import eventClient from '@/common/apiClient/eventClient';
import { useEffect } from 'react';

const useIdolInteraction = ({ actId, position, ref }) => {
    useEffect(() => {
        if (!actId || !ref?.current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    eventClient.postIdolInteraction({
                        id: actId,
                        position,
                        eventType: 'impression',
                    });
                    observer.disconnect(); // 只算一次
                }
            },
            { threshold: 0.9 }, // 露出 90% 才算
        );

        observer.observe(ref.current);
        return () => observer.disconnect();
    }, [actId, position, ref]);

    const handleClick = () => {
        if (!actId) return;
        eventClient.postIdolInteraction({ id: actId, position, eventType: 'click' });
    };

    return { handleClick };
};
export default useIdolInteraction;
